// CONSTANTS are all caps.
const NS = 'SiteHeader';
const CLS = 'siteHeader';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadWg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class SiteHeader {
	constructor($el) {
		// $el is the widget node return by the loadDemo function
		this.$el = $el;
	}

	init() {
		this.setSiteHeader();
	}

	setSiteHeader() {
		// Add Some logic here
		let $wg = $(this.$el);
		let $smartSearchToggle = $wg.find('.smartSearch-toggle'); // is-open
		let $cartToggle = $wg.find('.cart-toggle'); // is-open
		let $navbarToggle = $wg.find('.navbar-toggler'); // collapsed

		$wg.on('click', '.smartSearch-toggle', function() {
			if ($(this).hasClass('is-open')) {
				if ($cartToggle.hasClass('is-open')) {
					$cartToggle.trigger('click');
				}
				if (!$navbarToggle.hasClass('collapsed')) {
					$navbarToggle.trigger('click');
				}
			}
		});

		$wg.on('click', '.cart-toggle', function() {
			if ($(this).hasClass('is-open')) {
				if ($smartSearchToggle.hasClass('is-open')) {
					$smartSearchToggle.trigger('click');
				}
				if (!$navbarToggle.hasClass('collapsed')) {
					$navbarToggle.trigger('click');
				}
			}
		});

		$wg.on('click', '.navbar-toggler', function() {
			if ($(this).hasClass('collapsed')) {
				if ($cartToggle.hasClass('is-open')) {
					$cartToggle.trigger('click');
				}
				if ($smartSearchToggle.hasClass('is-open')) {
					$smartSearchToggle.trigger('click');
				}
			}
		});
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/siteHeader/js/siteHeader.js